import axios from "axios";
import Rx from "rxjs";

import { CONNECTLY_API_URL } from "config/globals";

  const instance = axios.create()

class ApiConnectlyService {
  getIntegrationUpdateInfo = async (id) => {
    return await instance.get(`https://api.s.connectly.travel/connectly-api/api/connectly/integration_update/${id}`)
  }

  updateIntegrationUpdate = async (data) => {
    return await instance.post(`https://api.s.connectly.travel/connectly-api/api/connectly/integration_update`, data)
  }

  getIntegrationLogs = async (data) => {
    return await instance.post(`https://api.s.connectly.travel/connectly-api/api/connectly/events_logs`, data)
  }
}

export default new ApiConnectlyService();



// WEBPACK FOOTER //
// ./src/lib/services/ApiConnectlyService.js